import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'

// import { STEPS } from '../../../../../store/slices/scheduleTour'

// Components
import { Button, Text } from '../../../..'
import { IconArrowLeft } from '../../../../shared/Icon'

// Styles
import styles from './StepHeaderNavSection.module.scss'

export interface StepHeaderProps {
  children?: React.ReactNode
  currentStep: string
  steps: string[]
  onBack: () => void
  onCancel: () => void
}

export const StepHeaderNavSection = ({ children, currentStep, steps, onBack, onCancel }: StepHeaderProps) => {
  const stepIndex = steps.indexOf(currentStep)

  return (
    <div className={styles.header}>
      <Button
        className={classnames(styles.backButton, (stepIndex === 0 || stepIndex === steps.length - 1) && styles.hidden)}
        iconStart={IconArrowLeft}
        onClick={onBack}
        minimal
      >
        <FormattedMessage id='Buttons.navigation.back' defaultMessage='Back' />
      </Button>
      <Text variant='neutralCool' variantCount='900' align='center' element='h3' weight='semibold' size='m'>
        {!children && (
          <FormattedMessage
            id='ScheduleTour.stepProgressCounter'
            defaultMessage='Step {currentStep} of {totalSteps}'
            values={{
              currentStep: stepIndex + 1,
              totalSteps: steps.length - 1
            }}
          />
        )}
        {children}
      </Text>
      <Button
        minimal
        className={classnames(styles.cancelButton, stepIndex === steps.length - 1 && styles.hidden)}
        onClick={onCancel}
      >
        <FormattedMessage id='general.cancel' defaultMessage='Cancel' />
      </Button>
    </div>
  )
}
